// extracted by mini-css-extract-plugin
export default {"filter-column-height":"SummaryFilterBox_filter-column-height__xizK5","ipad-pro-filterbox":"SummaryFilterBox_ipad-pro-filterbox__xu-WJ"};